export enum ProductStateFormFields {
	name = 'name',
	code = 'code',
	isActive = 'isActive'
}

export enum ProductStateSearchResultFields {
	searchById = 'searchById',
	searchByName = 'searchByName',
	searchByCode = 'searchByCode'
}

export enum ProductStateFilterFields {
	includeInactive = 'includeInactive'
}

export declare namespace ProductState {
	interface Basic extends Entity {
		code: string
		isActive: boolean
	}
	namespace Form {
		interface Generic extends NameCode {
			isActive: boolean
		}
	}
	namespace Request {
		interface Generic extends Form.Generic {}
	}

	namespace Search {
		interface Result {
			[ProductStateSearchResultFields.searchById]: Entity[]
			[ProductStateSearchResultFields.searchByName]: Entity[]
			[ProductStateSearchResultFields.searchByCode]: { id: number; code: string }[]
		}
	}
}
